import React, { useState, useEffect } from 'react';

import {
  Modal,
  TextInput,
  InputSelect,
  DatePickerInput,
  DragAndDropFileUploaderInput,
} from '@wajeez-web/components/ui';
import { CommonModalProps } from './Types';

import {
  OfferCodeGroupType,
  ProductOutput,
  PromoCodeType,
  PriceTemplateType,
} from '@wajeez-web/core/types';

const offerCodeGroupInitialState: OfferCodeGroupType = {
  GroupId: '',
  Expiry: '',
  PromoCodeId: '',
  ProductId: '',
  PriceTemplateId: '',
  OfferCodes: null,
};

interface OfferCodeGroupModalProps
  extends CommonModalProps<OfferCodeGroupType> {
  promoCodes: PromoCodeType[];
  products: ProductOutput[];
  priceTemplates: PriceTemplateType[];
}

const OfferCodeGroupModal: React.FC<OfferCodeGroupModalProps> = ({
  isOpen,
  onClose,
  data,
  promoCodes,
  onSubmit,
  products,
  priceTemplates,
}) => {
  const [offerCodeGroup, setOfferCodeGroup] = useState<OfferCodeGroupType>(
    offerCodeGroupInitialState
  );

  const handleChange = (name: string, value: any) => {
    setOfferCodeGroup({ ...offerCodeGroup, [name]: value });
  };

  const promoCodeSelectOptions = () => {
    return promoCodes?.map((promoCode) => {
      return {
        label: promoCode.name,
        value: promoCode.id,
      };
    });
  };

  const productSelectOptions = () => {
    return products?.map((product) => {
      return {
        label: product.name + '-' + product.purchaseProviderKey,
        value: product.id,
      };
    });
  };

  const priceTemplateSelectOptions = () => {
    return priceTemplates?.map((priceTemplate) => {
      return {
        label: priceTemplate.name,
        value: priceTemplate.id,
      };
    });
  };

  useEffect(() => {
    data
      ? setOfferCodeGroup({ ...data })
      : setOfferCodeGroup(offerCodeGroupInitialState);
  }, [data]);

  return (
    <Modal
      title={'Offer Code Group'}
      open={isOpen}
      onClose={onClose}
      withScroll={true}
      onSubmit={() => {
        onSubmit && onSubmit(offerCodeGroup);
      }}
    >
      <div className="space-y-3">
        <TextInput
          label="Group ID"
          name="GroupId"
          value={offerCodeGroup.GroupId}
          onChange={handleChange}
          required={true}
        />
        <InputSelect
          label="Promo Code"
          name="PromoCodeId"
          value={promoCodeSelectOptions()?.find(
            (item) => item.value.toString() === offerCodeGroup.PromoCodeId
          )}
          onChange={(name, val: any) => {
            setOfferCodeGroup({ ...offerCodeGroup, PromoCodeId: val?.value });
          }}
          options={promoCodeSelectOptions()}
        />
        <InputSelect
          label="Product"
          name="ProductId"
          value={productSelectOptions()?.find(
            (item) => item.value.toString() === offerCodeGroup.ProductId
          )}
          onChange={(name, val: any) => {
            setOfferCodeGroup({ ...offerCodeGroup, ProductId: val?.value });
          }}
          options={productSelectOptions()}
        />
        <InputSelect
          label="Price Template"
          name="PriceTemplateId"
          value={priceTemplateSelectOptions()?.find(
            (item) => item.value.toString() === offerCodeGroup.PriceTemplateId
          )}
          onChange={(name, val: any) => {
            setOfferCodeGroup({
              ...offerCodeGroup,
              PriceTemplateId: val?.value,
            });
          }}
          options={priceTemplateSelectOptions()}
        />
        <DatePickerInput
          label="Expiry"
          showTime={true}
          name="Expiry"
          value={offerCodeGroup.Expiry}
          onChange={handleChange}
        />
        <DragAndDropFileUploaderInput
          label="Offer Codes"
          name="OfferCodes"
          required={true}
          onChange={(name, formData) => {
            setOfferCodeGroup({
              ...offerCodeGroup,
              OfferCodes: formData.get('file'),
            });
          }}
        />
      </div>
    </Modal>
  );
};

export default OfferCodeGroupModal;
